module.exports = __webpack_public_path__ + "img/AlSalam1.2952144f.jpg";